export default __webpack_public_path__ + "static/media/BadSmiley.a6b72ed3.svg";